/*
 * @Author: cc
 * @Date: 2019-12-19 11:16:32
 * @LastEditTime: 2021-10-27 15:29:28
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\newMediaPreview\newMediaPreview.js
 * @Description:百家号查看页
 */

'use strict';
angular.module('editCenterNewMediaPreviewModule', ['editcenterNewMediaPreviewRouterModule']).controller('editCenterNewMediaPreviewCtrl', [
    '$scope',
    '$element',
    '$compile',
    '$q',
    '$state',
    'trsHttpService',
    'newMediaService',
    'editingCenterService',
    '$stateParams',
    'editcenterRightsService', 
    'newMediaPreviewType',
    'modalDialog',
    'trsPrintService',
    'localStorageService',
    function ($scope, $element, $compile, $q, $state, trsHttpService, newMediaService, editingCenterService, $stateParams, editcenterRightsService, newMediaPreviewType, modalDialog, trsPrintService, localStorageService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.rightsList = ['baijiahao.daibian.bianji', 'baijiahao.daishen.bianji', 'kuaibao.daibian.edit', 'kuaibao.daishen.edit', 'toutiao.daibian.bianji', 'toutiao.daishen.bianji', 'iwo.personal.bianji', 'iwo.received.bianji'];
            // 请求权限方法
            $scope.initBtnRightsMethods = {
                18: editcenterRightsService.initBaiJiaHaoListBtn,
                20: editcenterRightsService.initToutiaohaoListBtn,
                19: editcenterRightsService.initQieHaoListBtn,
            };
            // 基础稿件查询参数集合
            $scope.basicParams = {
                18: {
                    serviceid: 'mlf_baijiahao',
                    methodName: 'getBaiJiaHaoArticle',
                    baiJiaHaoArticleId: $state.params.metadataid,
                    fromsearch: $state.params.fromsearch
                },
                19: {
                    serviceid: 'mlf_kuaibaoarticle',
                    methodName: 'getDocs',
                    ArticleId: $state.params.metadataid,
                    fromsearch: $state.params.fromsearch
                },
                20: {
                    serviceid: 'mlf_toutiao',
                    methodName: 'getTouTiaoArticle',
                    METADATAID: $state.params.metadataid,
                    CHANNELID: $state.params.account,
                    fromsearch: $state.params.fromsearch
                }
            };
            // 融合稿件查询参数集合
            $scope.fusionParams = {
                18: {
                    serviceid: 'mlf_fusionbaijia',
                    methodname: 'getBaiJiaVirtualDoc',
                    SourceDocId: $state.params.iwometadataid,
                },
                19: {
                    serviceid: 'mlf_fusionkuaibao',
                    methodname: 'getKuaiBaoVirtualDoc',
                    SourceDocId: $state.params.iwometadataid,
                },
                20: {
                    serviceid: 'mlf_fusiontoutiao',
                    methodname: 'getTouTiaoVirtualDoc',
                    SourceDocId: $state.params.iwometadataid,
                }
            };
            $scope.status = {
                previewBigFace: {
                    status: false,
                }, // 查看痕迹
                listOpen: 1, // 右边侧栏信息默认第一个展开
                showEditButton: false,
                isCanEdit: false, // 是否可以编辑，编辑按钮权限
                isFusionPreview: $state.current.name === 'fusionpreview', // 预览页面是否是来自预览页面
                docType: '', // 稿件类型，为了兼容百家号渠道稿（字段为DOCKIND）和虚拟稿（字段为DOCTYPE）
                isawaitrevise: !!$state.params.isawaitrevise,
                plantform: $state.params.plantform,
                isFusion: !!$state.params.iwometadataid // 是否处于融合渠道
            };  
            $scope.data = {
                fromsearch: $stateParams.fromsearch,
                copyVersion: [],
                detail: {},
                mediaType: $state.params.mediatype
            };
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]
         */
        function initData() {
            if (!$state.params.versionid) {
                requestData().then(function () { // 存在versionid表示是版本模式
                    loadDirective();
                    getDraftStage();
                    loadVersionTimePanel();
                });
            } else {
                editingCenterService.flowVersion($state.params.versionid).then((data) => {
                    $scope.data.detail = data;
                    loadDirective();
                });
            }
            getVersion();
        }

        /**
         * [requestData description]数据请求
         * @param  {[obj]} params [description]请求参数
         * @return {[obj]}        [description]请求返回值
         */
        function requestData() {
            var deferred = $q.defer();
            var params = $scope.status.isFusionPreview ? $scope.fusionParams[$state.params.mediatype] : $scope.basicParams[$state.params.mediatype];
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                specialHandle(data);
                $scope.data.detail = data;
                $scope.data.item = data;
                document.title = data.TITLE;
                var accountId = data.ACCOUNTID || data.BAIJIAHAOACCOUNTID || data.CHANNELID; // 请求权限所需账户id
                if (!$stateParams.iwometadataid) {
                    initChannelBtnRights(data, accountId);
                    editingCenterService.queryVerifyDoc($scope.data.item);
                } else {
                    initIwoListBtnRights();
                }
                $scope.status.docType = data.DOCTYPEID || data.DOCTYPE; // 1为新闻稿 2为图集稿 7为视频稿
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [getDraftStage description] 获取当前稿件在哪个审核阶段（去除需要传入的wzplatform的情况，主要是从IM来的稿件）
         * @return  {[type]}  [return description]
         */
        function getDraftStage() {
            editingCenterService.getDraftStage($scope.data.item, {
                mediatype: $state.params.mediatype,
                metadataid: $state.params.metadataid
            }).then((data) => {
                $scope.data.detail.PLATFORM = data;
            });
        }

        /**
         * [specialHandle description] 单独特殊处理
         * @param   {[object]}  data  [data description] 稿件详情
         * @return  {[type]}          [return description]
         */
        function specialHandle(data){
            var params = $scope.status.isFusionPreview ? $scope.fusionParams[$state.params.mediatype] : $scope.basicParams[$state.params.mediatype];
            if (data.VIDEOREL && data.VIDEOREL.length && (params.serviceid === 'mlf_kuaibaoarticle' || params.serviceid === 'mlf_fusionkuaibao')){
                data.HTMLCONTENT = ''; // 根据后端要求屏蔽
            }
        }

        /**
         * [initBtnRights description]初始化权限(渠道进入的)
         * @param  {[obj]} data [description]请求参数
         * @param  {[obj]} accountId [description]请求参数
         * @return {[obj]}        [description]请求返回值
         */
        function initChannelBtnRights(data, accountId) {
            let classify = newMediaPreviewType[$state.params.mediatype][data.PLATFORM]; // 权限分类
            if (!classify) {return;}
            $scope.initBtnRightsMethods[$state.params.mediatype](classify, accountId).then((rights) => {
                $scope.status.btnRights = rights;
                dealRights(rights);
            });
        }

        /**
         * [initBtnRights description]初始化权限(iwo进入的)
         * 
         * @return {[obj]}        [description]请求返回值
         */
        function initIwoListBtnRights() {
            editcenterRightsService.initIwoListBtn($stateParams.iwomodalname).then(function(data) {
                $scope.status.btnRights = data;
                dealRights(data);
            });
        }

        /**
         * [dealRights description]
         * @param   {[type]}  rights  [rights description]
         * @return  {[type]}          [return description]
         */
        function dealRights(rights) {
            for (let key in rights) {
                if ($scope.rightsList.includes(key)) {
                    $scope.status.showEditButton = true;
                }
            }
        }

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            newMediaService.previewLoadDirective($element, $compile, $scope);
        }

        /**
         * [close description]关闭页面
         *
         * @return  {[type]}  [return description]
         */
        $scope.close = function () {
            window.close();
        };

        /**
         * [goToEdit description] 跳转编辑页
         *
         * @return  {[type]}  [return description]
         */
        $scope.goToEdit = function() {
            // 这一步是从融合编辑跳转过来的属于虚拟稿件，这个时候还没有mediatype等信息，就不执行加锁等操作。
            if ($state.params.iwometadataid) {
                $scope.data.detail.MEDIATYPE = $state.params.mediatype;
                $scope.data.detail.noNeedLock = true;
            }
            // // 后端返回的 platform与前端用的platform多了一(为了做最少的改动,就这-1) 编辑页的按钮
            // $scope.data.detail.PLATFORM = $scope.data.detail.PLATFORM - 1;
            editingCenterService.routerToEditorWithLock(angular.extend($scope.data.detail));
        };
        
        $scope.creationAxis = function() {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'addPersonalMaterialOfTxt',
                PersonalMaterialId: 0,
                metadataid: $stateParams.metadataid || $stateParams.iwometadataid,
                MediaType: $state.params.mediatype,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };
        $scope.printBtn = function() {
            requestPrintVersion($stateParams.metadataid || $stateParams.iwometadataid).then(function(data) {
                requestPrintData(data);
            });
        };

        /**
         * [requestPrintVersion description]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function requestPrintVersion(item) {
            var deferred = $q.defer();
            trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), { serviceid: 'mlf_metadatalog', methodname: 'query', MetaDataId: item }, 'get')
                .then(function(data) {
                    deferred.resolve(data.DATA);
                });
            return deferred.promise;
        }
        
        /**
         * [requestPrintVersion description]
         *
         * @param   {[type]}  version  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function requestPrintData(version) {
            var params = $scope.status.isFusionPreview ? $scope.fusionParams[$state.params.mediatype] : $scope.basicParams[$state.params.mediatype];
            $scope.data.printResult = [];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                trsPrintService.trsWebPrintDocument($scope.data.printResult);
            });

        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function (direction) {
            var pageTurningData;
            if (!!$stateParams.iwometadataid) {
                pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
            } else {
                pageTurningData = JSON.parse(localStorageService.get('newMediaPreview'));
            }
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].METADATAID === $stateParams.metadataid || $stateParams.iwometadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go($state.current.name, {
                metadataid: toPageData.METADATAID,
                iwometadataid: toPageData.METADATAID,
                mediatype: toPageData.MEDIATYPE,
                account: $state.params.PRODUCTID || $state.params.account,
                isawaitrevise: toPageData.DOCMODIFYSTATUSNAME
            }, {
                reload: true
            });
        };

        $scope.getLoadMore = function() {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [getVersion description]获得操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersion() {
            var deffer = $q.defer();
            var metadataid = $stateParams.metadataid || $stateParams.iwometadataid; // 可能是从融合编辑跳过来
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function(data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    deffer.resolve();
                },
                function() {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [bigFace description] 查看痕迹
         * @return {[type]} [description]
         */
        // $scope.bigFace = function() {
        //     $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        // };

        /**
         * [loadVersionTimePanel 动态加载流程版本信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadVersionTimePanel() {
            var versionPanel =
                '<version-time-panel incoming-data="data.item"></version-time-panel>';
            versionPanel = $compile(versionPanel)($scope);
            $element.find('versionPanel').append(versionPanel);
        }
    },
]);
